import type { ApiConfig, FetchApiData, FetchSubTypes } from '../types'
import { depositHistoryApiConfig } from './depositHistory/constants'
import { fetchApiData as fetchDepositHistoryApiData } from './depositHistory/fetchApiData'
import { futureLinearHistoryApiConfig } from './futureLinearHistory/constants'
import { fetchApiData as fetchFutureLinearHistoryApiData } from './futureLinearHistory/fetchApiData'
import { spotTradeHistoryApiConfig } from './spotTradeHistory/constants'
import { fetchApiData as fetchSpotTradeHistoryApiData } from './spotTradeHistory/fetchApiData'
import { utaTransactionHistoryApiConfig } from './utaTransactionHistory/constants'
import { fetchApiData as fetchUtaTransactionHistoryApiData } from './utaTransactionHistory/fetchApiData'
import { withdrawalHistoryApiConfig } from './withdrawalHistory/constants'
import { fetchApiData as fetchWithdrawalHistoryApiData } from './withdrawalHistory/fetchApiData'

export const bybitApiConfigs = {
  [depositHistoryApiConfig.type]: depositHistoryApiConfig,
  [futureLinearHistoryApiConfig.type]: futureLinearHistoryApiConfig,
  [spotTradeHistoryApiConfig.type]: spotTradeHistoryApiConfig,
  [utaTransactionHistoryApiConfig.type]: utaTransactionHistoryApiConfig,
  [withdrawalHistoryApiConfig.type]: withdrawalHistoryApiConfig,
} as const satisfies Record<string, ApiConfig>

export type BybitApiType = keyof typeof bybitApiConfigs

export const bybitApiTypes = Object.keys(bybitApiConfigs) as BybitApiType[]

export const fetchBybitApiDataFuncs = {
  [depositHistoryApiConfig.type]: fetchDepositHistoryApiData,
  [futureLinearHistoryApiConfig.type]: fetchFutureLinearHistoryApiData,
  [spotTradeHistoryApiConfig.type]: fetchSpotTradeHistoryApiData,
  [utaTransactionHistoryApiConfig.type]: fetchUtaTransactionHistoryApiData,
  [withdrawalHistoryApiConfig.type]: fetchWithdrawalHistoryApiData,
} as const satisfies Record<string, FetchApiData>

export const fetchBybitSubTypesFuncs = {
  [depositHistoryApiConfig.type]: undefined,
  [futureLinearHistoryApiConfig.type]: undefined,
  [spotTradeHistoryApiConfig.type]: undefined,
  [utaTransactionHistoryApiConfig.type]: undefined,
  [withdrawalHistoryApiConfig.type]: undefined,
} as const satisfies Record<string, FetchSubTypes | undefined>

export { getCurrentBybitAssets } from './getCurrentAsset'
